import './../../css/scss/blocks/articles.scss';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
  function initProductsAfterSwiper() {
    const productsAfter = document.querySelector('.article-page__products--after');
    if (!productsAfter) return;
    const swiperEl = productsAfter.querySelector('.swiper');
    if (!swiperEl || productsAfter.swiperInited) return;

    new Swiper(swiperEl, {
      modules: [Navigation, Pagination],
      freeMode: false,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      simulateTouch: true,
      lazy: {
        loadOnTransitionStart: true,
        loadPrevNextAmount: 2,
        loadPrevNext: true
      },
        on: {
            init: checkSwiperEndState,
            slideChange: checkSwiperEndState,
            touchEnd: checkSwiperEndState,
            resize: checkSwiperEndState,
        },
      loop: false,
      followFinger: true,
      spaceBetween: 0,
      navigation: {
        nextEl: productsAfter.querySelector('.swiper-button-next'),
        prevEl: productsAfter.querySelector('.swiper-button-prev'),
        disabledClass: 'swiper-lock'
      },
      breakpoints: {
        0: { slidesPerView: 1.85, slidesPerGroup: 1 },
        640: { slidesPerView: 2, slidesPerGroup: 1 },
        769: { slidesPerView: 3, slidesPerGroup: 1 },
        992: { slidesPerView: 4, slidesPerGroup: 1 },
        1200: { slidesPerView: 5.3, slidesPerGroup: 1 },
        1366: { slidesPerView: 6, slidesPerGroup: 1 },
      }
    });
      function checkSwiperEndState(swiper) {
          const container = swiper.el.closest('[data-slider="common-slider"]');
          if (!container) return;

          container.classList.toggle('is-end', swiper.isEnd);

          const nextBtn = container.querySelector('.js-next-swiper');
          const prevBtn = container.querySelector('.js-prev-swiper');

          const shouldHideNav = swiper.isLocked;
          [nextBtn, prevBtn].forEach(btn => {
              if (btn) {
                  btn.style.display = shouldHideNav ? 'none' : '';
              }
          });
      }
    productsAfter.swiperInited = true;
  }

  function showMobileProductsCarouselIfSidebarHidden() {
    const sidebar = document.querySelector('.article-page__sidebar');
    const productsAfter = document.querySelector('.article-page__products--after');
    if (!productsAfter) return;
    if (!sidebar || getComputedStyle(sidebar).display === 'none') {
      productsAfter.style.display = 'block';
      initProductsAfterSwiper();
    } else {
      productsAfter.style.display = 'none';
    }
  }

  showMobileProductsCarouselIfSidebarHidden();
  window.addEventListener('resize', showMobileProductsCarouselIfSidebarHidden);
});
